import type { Article } from "../../../types/content";
import type { FeedItem } from "../../../types/content/feedItem";

import { isFeedItem } from "../../../utils/typechecks";

const mapTeaserStyle = (item: FeedItem): "native" | "premium" | "regular" => {
  if (!isFeedItem(item)) {
    return "regular";
  }

  const firstArticle = item.articles[0];
  if (!firstArticle) {
    if (item.type === "Box" && item?.style) {
      return item.style;
    }
    return "regular";
  }

  return (firstArticle as Article).style || "regular";
};

export { mapTeaserStyle };
